import { Link } from "react-router-dom";

import { APP_NAME } from "../constants/brand";

export function TermsPage() {
  return (
    <section className="legal-page">
      <header className="legal-header">
        <Link to="/auth" className="legal-back-link">&larr; Torna al login</Link>
        <h1>Condizioni d&apos;uso</h1>
        <p className="legal-meta">Ultimo aggiornamento: 23 maggio 2026</p>
      </header>

      <article className="legal-content">
        <p>
          Le presenti condizioni regolano l&apos;accesso e l&apos;utilizzo del servizio{" "}
          <strong>{APP_NAME}</strong>. Registrandoti, l&apos;utente dichiara di averle lette,
          comprese e accettate integralmente.
        </p>

        <h2>1. Oggetto del servizio</h2>
        <p>
          {APP_NAME} è una piattaforma SaaS multi-tenant per la gestione di solleciti di pagamento
          tramite email e WhatsApp, con automazioni configurabili (policy di escalation, template,
          integrazioni AI). Il servizio è erogato in modalità &laquo;as a service&raquo; tramite
          accesso autenticato dal browser.
        </p>

        <h2>2. Registrazione e account</h2>
        <ul>
          <li>
            L&apos;utente deve fornire dati veritieri, aggiornati e completi al momento della
            registrazione.
          </li>
          <li>
            L&apos;account è personale e non cedibile a terzi. L&apos;utente è responsabile della
            riservatezza delle credenziali di accesso.
          </li>
          <li>
            La registrazione richiede la verifica dell&apos;indirizzo email tramite codice OTP o
            link di conferma.
          </li>
        </ul>

        <h2>3. Piani, abbonamenti e fatturazione</h2>
        <ul>
          <li>
            L&apos;utilizzo del servizio richiede l&apos;attivazione di un piano a pagamento. I
            piani disponibili, le funzionalità incluse e i limiti d&apos;uso sono pubblicati sulla
            pagina &laquo;Piani&raquo;.
          </li>
          <li>
            Il pagamento è gestito tramite <strong>Stripe Payments Europe Ltd.</strong>
            L&apos;abbonamento si rinnova automaticamente salvo disdetta.
          </li>
          <li>
            Il diritto di recesso ex art. 59 del Codice del Consumo non si applica ai servizi
            digitali iniziati con il consenso espresso dell&apos;utente.
          </li>
        </ul>

        <h2>4. Obblighi dell&apos;utente</h2>
        <p>L&apos;utente si impegna a:</p>
        <ul>
          <li>
            Utilizzare il servizio nel rispetto della normativa applicabile, in particolare in
            materia di protezione dei dati personali (GDPR) e di comunicazioni commerciali (D.Lgs.
            206/2005, D.Lgs. 70/2003).
          </li>
          <li>
            Trattare i dati dei propri debitori come <strong>titolare del trattamento</strong>,
            avendo {APP_NAME} ruolo di responsabile ex art. 28 GDPR.
          </li>
          <li>
            Fornire ai propri debitori l&apos;informativa privacy prevista dagli artt. 13 e 14 GDPR,
            includendo il riferimento al trattamento AI svolto tramite {APP_NAME} (vedi{" "}
            <Link to="/privacy">Informativa Privacy</Link>).
          </li>
          <li>
            Non utilizzare il servizio per finalità illecite, fraudolente, diffamatorie o lesive di
            diritti di terzi.
          </li>
          <li>
            Non aggirare i limiti d&apos;uso, non tentare di accedere a workspace di altri utenti,
            non eseguire reverse engineering della piattaforma.
          </li>
          <li>
            Rispettare le policy di Meta WhatsApp Business e dei provider SMTP utilizzati, in
            particolare in materia di anti-spam e contenuti commerciali.
          </li>
        </ul>

        <h2>5. Ruoli GDPR</h2>
        <p>
          Rispetto ai dati caricati dall&apos;utente sui propri debitori:
        </p>
        <ul>
          <li>
            <strong>Titolare del trattamento</strong>: l&apos;utente (studio professionale o azienda)
          </li>
          <li>
            <strong>Responsabile del trattamento</strong>: {APP_NAME}
          </li>
          <li>
            <strong>Sub-responsabili</strong>: i provider tecnologici utilizzati (Mistral AI,
            Google, Meta, Stripe, provider SMTP). L&apos;elenco aggiornato è riportato nella{" "}
            <Link to="/privacy">Informativa Privacy</Link>.
          </li>
        </ul>
        <p>
          L&apos;accettazione delle presenti condizioni vale come <strong>nomina a responsabile del
          trattamento</strong> ex art. 28(3) GDPR, con clausole standard rese disponibili su
          richiesta scritta dell&apos;utente.
        </p>

        <h2>6. Livelli di servizio e disponibilità</h2>
        <p>
          {APP_NAME} si impegna a mantenere un livello di disponibilità adeguato al normale utilizzo
          professionale del servizio. Il servizio è fornito &laquo;as is&raquo;: non sono garantite
          assenza di interruzioni, errori o vulnerabilità. Sono previsti interventi di manutenzione
          programmata, comunicati con preavviso quando possibile.
        </p>

        <h2>7. Proprietà intellettuale</h2>
        <p>
          Tutti i diritti sulla piattaforma {APP_NAME}, sul software, sui contenuti e sui marchi
          restano di titolarità dei rispettivi proprietari. L&apos;utente acquisisce esclusivamente
          un diritto d&apos;uso non esclusivo, limitato alla durata dell&apos;abbonamento. I dati
          caricati dall&apos;utente restano di sua proprietà.
        </p>

        <h2>8. Limitazione di responsabilità</h2>
        <p>
          Nei limiti consentiti dalla legge, {APP_NAME} non risponde di danni indiretti, mancato
          guadagno o perdita di opportunità derivanti dall&apos;uso o dal mancato uso del servizio.
          L&apos;eventuale responsabilità è in ogni caso limitata all&apos;importo
          dell&apos;abbonamento corrisposto nei 12 mesi precedenti l&apos;evento dannoso.
        </p>

        <h2>9. Sospensione e recesso</h2>
        <p>
          {APP_NAME} si riserva il diritto di sospendere o disattivare l&apos;account in caso di
          violazione delle presenti condizioni, di mancato pagamento o di utilizzo illecito del
          servizio. L&apos;utente può recedere in qualsiasi momento disattivando l&apos;abbonamento
          dalla pagina &laquo;Fatturazione&raquo;.
        </p>

        <h2>10. Modifiche</h2>
        <p>
          {APP_NAME} può aggiornare le presenti condizioni. Le modifiche sostanziali saranno
          comunicate via email all&apos;indirizzo di registrazione, con almeno 15 giorni di
          preavviso rispetto all&apos;entrata in vigore.
        </p>

        <h2>11. Legge applicabile e foro competente</h2>
        <p>
          Le presenti condizioni sono regolate dalla legge italiana. Per ogni controversia è
          competente in via esclusiva il foro del Tribunale di residenza/sede del titolare di
          {APP_NAME}, salvo i fori inderogabili previsti dal Codice del Consumo per i consumatori.
        </p>
      </article>

      <footer className="legal-footer">
        <Link to="/privacy">Informativa Privacy</Link>
        <span>·</span>
        <Link to="/auth">Login</Link>
      </footer>
    </section>
  );
}
